module.exports = __webpack_public_path__ + "img/icon1.43cd527e.png";